import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll immédiatement
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    
    // Double vérification après un court délai (pour gérer les cas de chargement asynchrone)
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);
    
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};
